export default __webpack_public_path__ + "img/close-circle-black.e13334f1.svg";